import React, { useState } from "react";
// import Button from '@material-ui/core/Button';
// import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogTitle from '@material-ui/core/DialogTitle';
import getCroppedImg from "../ImageEditor/cropImage";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';
import Cropper from 'react-easy-crop'
import CropIcon from '@material-ui/icons/Crop';


export default function AddPhotoModal({ imagePath, open, handleClose, cropWidth, cropHeight, convertToBase64 }) {
    let cWidth = parseInt(cropWidth.slice(0, -2)) + 50;
    let cHeight= parseInt(cropHeight.slice(0, -2)) + 50;
  //  let diem = `cWidth:${cWidth}, cHeight:${cHeight}`
    const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const cropComplete = (croppedArea, croppedAreaPixels) => {
    console.log(croppedAreaPixels);
    setCroppedAreaPixels(croppedAreaPixels);
  };
  const cropImage = async () => {

    try {
      const data = await getCroppedImg(
        imagePath,
        croppedAreaPixels,
        rotation
      );

    convertToBase64(data)

    } catch (error) {
    
      console.log(error);
    }

  };
  
 
  return (
    <div>
     
      <Dialog fullWidth open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth={`md`} >
        <DialogTitle id="form-dialog-title" className="modal-title">Add Photo Box</DialogTitle>
        <form >
        <DialogContent style={{height:'500px'}} >
           <Cropper
          image={imagePath}
          crop={crop}
          zoom={zoom}
          rotation={rotation}
       
          cropSize={{width:cWidth, height:cHeight}}
          onZoomChange={setZoom}
          onRotationChange={setRotation}
          onCropChange={setCrop}
          onCropComplete={cropComplete}
        />
        </DialogContent>
        <DialogActions sx={{ flexDirection: 'column', mx: 3, my: 2 }}>
        {/* <Box sx={{ width: '100%', mb: 1 }}>
          <Box>
            <Typography>Zoom: {zoomPercent(zoom)}</Typography>
            <Slider
              valueLabelDisplay="auto"
              valueLabelFormat={zoomPercent}
              min={1}
              max={3}
              step={0.1}
              value={zoom}
              onChange={(e, zoom) => setZoom(zoom)}
            />
          </Box>
          <Box>
            <Typography>Rotation: {rotation + '°'}</Typography>
            <Slider
              valueLabelDisplay="auto"
              min={0}
              max={360}
              value={rotation}
              onChange={(e, rotation) => setRotation(rotation)}
            />
          </Box>
        </Box> */}
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
         
          <Button
            variant="contained"
            startIcon={<CropIcon />}
            onClick={cropImage}
          >
            Crop
          </Button>
        </Box>
      </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
// const zoomPercent = (value) => {
//   return `${Math.round(value * 100)}%`;
// };